module.exports = ".icosub {\n    background-color: red;\n}"